import { useEffect, useState } from 'react'
import {
  useShareFileMutation,
  ShareFile,
  useLazySharerDetailsQuery,
} from '../app/appApiQueries'
import { useAppDispatch, useAppSelector } from './useRTK'
import { App, selectApp, selectCollaborationId } from '../app/root'
import { closeDialog } from '../app/dialog'

export const useShareFile = () => {
  const dispatch = useAppDispatch()
  const app = useAppSelector(selectApp) as App
  const collaborationId = useAppSelector(selectCollaborationId)
  const [getSharerDetails] = useLazySharerDetailsQuery()
  const [shareFile] = useShareFileMutation({
    fixedCacheKey: 'share-file',
  })
  const [fileData, setFileData] = useState<Omit<
    ShareFile,
    'collaborationId'
  > | null>(null)

  useEffect(() => {
    if (fileData?.fileUrl && collaborationId) {
      shareFile({ ...fileData, collaborationId })
        .unwrap()
        .then(async () => {
          await getSharerDetails(app)
        })
        .finally(() => {
          dispatch(closeDialog())
        })
    }
  }, [app, collaborationId, dispatch, fileData, getSharerDetails, shareFile])

  return setFileData
}
